import { createSelector } from 'reselect';
import { find, get } from 'lodash';
import { StoreState } from '../store-interfaces';
import PageModel, { PageKind } from '../model/PageModel';
import ChatbotModel from '../model/ChatbotModel';
import { SessionObject } from '../interfaces/session';

const selectPages = (state: StoreState) => state.page.entities;
const selectActiveChatbot = (state: StoreState) => state.chatbot.activeChatbot;
const selectSessionSelector = (state: StoreState) => state.session.session;

const getWelcomePage = (pages: PageModel[]) =>
  find(pages, page => page.kind === PageKind.WelcomePage);

const getDefaultPage = (pages: PageModel[]) =>
  find(pages, page => page.kind === PageKind.DefaultPage);

const getGetStartedBot = (
  session: SessionObject,
  activeChatbot?: ChatbotModel,
) => {
  const onboardingSignupBot: number | undefined = get(
    session,
    'userAttributes.onboardingSignupBot',
  );

  if (
    onboardingSignupBot &&
    activeChatbot &&
    activeChatbot.id === onboardingSignupBot
  ) {
    return activeChatbot;
  }

  return null;
};

export const getOnboardingDialogue = (dialogues: PageModel[]) => {
  return dialogues.find(dialogue => dialogue.kind === 'onboarding_welcome');
};

export const welcomePageSelector = createSelector(
  [selectPages],
  getWelcomePage,
);

export const defaultPageSelector = createSelector(
  [selectPages],
  getDefaultPage,
);

export const getStartedBotSelector = createSelector(
  [selectSessionSelector, selectActiveChatbot],
  getGetStartedBot,
);
